import React from "../../__snowpack__/pkg/react.js";
import {InputNumber} from "../../__snowpack__/pkg/antd.js";
export const InputNumberInteger = (props) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(InputNumber, {
    parser: (value) => value?.replace(/[^\d]+/g, ""),
    ...props
  }));
};
